import { useParams } from 'react-router-dom';

export const useAppointmentParams = () =>
  useParams() as {
    tenantId: string;
    appointmentId: string;
  };
